import { render, staticRenderFns } from "./PdfViewerHeader.vue?vue&type=template&id=81452f20"
import script from "./PdfViewerHeader.vue?vue&type=script&lang=ts"
export * from "./PdfViewerHeader.vue?vue&type=script&lang=ts"
import style0 from "./PdfViewerHeader.vue?vue&type=style&index=0&id=81452f20&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports